<template>
  <div class="forum-single">
    <Header :title="forum_post.title" :subtitle="`postado por ${forum_post.user.nickname}`"></Header>
    <div class="container">
      <div class="forum-content">
        <div class="forum-header">
          <p>Postado em {{forum_post.created_at_friendly}}</p>
          <div v-if="forum_post.user.id == currentUser.id">
            <b-btn v-on:click.stop.prevent="deletePost" variant="outline-danger">apagar post</b-btn>
          </div>
        </div>
        <div class="forum-post">
          <div class="content" v-html="forum_post.content"></div>
        </div>
        <!-- <p class="replies">0 respostas</p>  -->

        <div v-if="forum_post.forum_responses.length > 0">
          <h5>respostas ({{forum_post.forum_responses.length}})</h5>
          <div class="forum-responses">
            <div
              class="forum-response"
              v-for="forum_response in forum_post.forum_responses"
              :key="forum_response.id"
            >
              <b-media>
                <b-img
                  :src="forum_response.user.avatar.url"
                  slot="aside"
                  width="64"
                  height="64"
                  alt="placeholder"
                />
                <p v-html="forum_response.content"></p>
                <div class="response-footer">
                  postado por
                  <router-link
                    :to="{ name: 'UserSingle', params: { id: forum_response.user.id }}"
                  >{{forum_response.user.nickname}}</router-link>em
                  <span v-html="forum_response.created_at_friendly"></span>

                  <div v-if="forum_response.user.id == currentUser.id">
                    <b-btn
                      v-on:click.stop.prevent="deleteComment(forum_response.id)"
                      size="sm"
                      variant="outline-danger"
                    >apagar</b-btn>
                  </div>
                </div>
              </b-media>
            </div>
          </div>
        </div>

        <div class="forum-respond" v-if="respondEnabled">
          <form @submit.stop.prevent="handleReplySubmit">
            <b-form-group description label="responda a este tópico">
              <ckeditor
                required
                :editor="editor"
                v-model="forum_response.content"
                :config="editorConfig"
              ></ckeditor>
            </b-form-group>
            <b-button type="submit" variant="primary">responder</b-button>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

export default {
  name: "ForumSingle",
  metaInfo() {
    return {
      title: `${this.forum_post.title}`
    };
  },
  computed: {
    currentUser: function() {
      return this.$store.getters.user;
    }
  },
  data() {
    return {
      forum_post: {
        title: "",
        content: "",
        user: { id: "", nickname: "", realname: "" },
        forum_responses: []
      },
      forum_response: { content: "" },
      respondEnabled: true,
      respondTimeout: Object,
      editor: ClassicEditor,
      editorData: "<p>Content of the editor.</p>",
      editorConfig: {
        toolbar: {
          items: ["bold", "italic", "link", "undo", "redo"]
        }
      }
    };
  },
  methods: {
    initialize() {
      this.$http
        .get("forum_posts/" + this.$route.params.id + ".json")
        .then(response => {
          this.forum_post = response.data;
        });
    },
    deletePost() {
      if (
        confirm(
          "Você tem certeza que deseja apagar esse post?\nAVISO: Essa ação não terá retorno."
        )
      ) {
        this.$http
          .delete(`forum_posts/${this.$route.params.id}.json`)
          .then(response => {
            this.$notify({
              group: "all",
              title: "Post apagado com sucesso"
            });
            this.$router.push({ name: "ForumList" });
          });
      }
    },
    deleteComment(forum_response_id) {
      if (
        confirm(
          "Você tem certeza que deseja apagar esse comentário?\nAVISO: Essa ação não terá retorno."
        )
      ) {
        this.$http
          .delete(
            `forum_posts/${
              this.$route.params.id
            }/forum_responses/${forum_response_id}.json`
          )
          .then(response => {
            this.$notify({
              group: "all",
              title: "Comentário apagado com sucesso"
            });
            this.initialize();
          });
      }
    },
    handleReplySubmit() {
      this.$http
        .post(`forum_posts/${this.$route.params.id}/forum_responses.json`, {
          forum_response: this.forum_response
        })
        .then(response => {
          this.$notify({
            group: "all",
            title: "Resposta criada!"
          });
          this.forum_response.content = "";
          this.initialize();

          this.respondEnabled = false;
        })
        .catch(response => {
          // alert(JSON.stringify(response.data))
        });
    }
  },
  mounted() {
    this.initialize();
  },
  watch: {
    "$route.params.id": function(id) {
      this.initialize();
    }
  },
  components: {
    Header
  }
};
</script>

<style lang="sass" scoped>
.forum-single
  .main-header
    margin-bottom: 0
  .container
    .forum-content
      background: rgba(255, 255, 255, .02)
      border-left: 1px solid rgba(255, 255, 255, .02)
      border-right: 1px solid rgba(255, 255, 255, .02)
      border-bottom: 1px solid rgba(255, 255, 255, .02)
      border-bottom-left-radius: 4px
      border-bottom-right-radius: 4px
      padding: 20px

      .forum-header
        padding: .5em 0 2em
        text-align: center
        margin: .5em 0 2em

      .content
        @media (max-width: 600px)
          img
            width: 100% !important
            height: auto !important
    .forum-post
      margin: -20px 0 100px 0
    .forum-response
      margin: 5px 0
      padding: 5px
      background: #dedede
      border-radius: 5px
      .response-footer
        font-size: 12px
        border-top: 1px solid #ccc
        padding: 5px 0 5px
</style>
